import React, { useState } from "react";
import CompanySelect from "../../../../Inputs/CompanySelect/CompanySelect";
import AddCompany from "../../../AddCompany/AddCompany";
import { useParams } from "react-router-dom";

export default function CompanyCarousel({ setSelectedCompany, selectedCompany }) {
  const [newCompany, setNewCompany] = useState(false);
  const handleNewCompany = () => setNewCompany((prev) => !prev);

  return (
    <>
      <div className={`carousel-item active`}>
        <div className="mt-5 companySection">
          <div className="row align-items-center mx-5 pt-5">
            <div className="col-md-6">
              <CompanySelect selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} />
            </div>
            <div className="col-md-6 text-md-end text-center">
              <button className={`btn ${newCompany ? "btn-danger" : "btn-primary"}`} onClick={handleNewCompany}>
                {newCompany ? "الغاء" : "اضافة شركة جديدة"}
              </button>
            </div>
          </div>
          {newCompany && (
            <div className="mx-5">
              <AddCompany handleNewCompany={handleNewCompany} />
            </div>
          )}
          <div className="mx-5 my-3">
            <h4>{selectedCompany?.label || ""}</h4>
          </div>
        </div>
        <div className="d-flex justify-content-between mx-5 my-3">
          <div></div>
          <button className={`btn btn-primary ${!selectedCompany?.value ? "d-none" : ""}`} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            التالي
          </button>
        </div>
      </div>
    </>
  );
}
